var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentsData.type == 26)?_c('div',{staticClass:"bg-div",style:(_vm.componentsData.content.version
            ? {
                  ...(_vm.componentsData.content.bg_color && {
                      backgroundColor: _vm.componentsData.content.bg_color,
                  }),
                  ...(_vm.componentsData.content.bg_img.picview &&
                      _vm.componentsData.content.bg_value && {
                          backgroundImage: `url(${_vm.componentsData.content.bg_img.picview})`,
                      }),
              }
            : `background: ${_vm.componentsData.content.bg_color};`)},[_c('div',{staticClass:"overflow-hidden",class:_vm.componentsData.content.iconList.length > 1
                ? 'flex-sb'
                : 'flex-c'},_vm._l((_vm.componentsData.content.iconList),function(item,index){return _c('div',{key:index,staticClass:"icon-div"},[_c('img',{staticClass:"wh24",attrs:{"src":item.img_list.picview}}),_c('div',{staticClass:"txt-container",style:(`color: ${_vm.componentsData.content.txt_color};`)},[_vm._v(" "+_vm._s(item.txt)+" ")])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }